import { FieldState } from 'formstate';

export class BusyFormState {
    /** Be sure to include this field in the FormState. */
    isBusy = new FieldState(false)
        .validators((value) => (value ? 'Busy' : null))
        .setAutoValidationDebouncedMs(0);

    setBusy(value: boolean) {
        this.isBusy.onChange(value);
    }

    withBusy<T>(promise: Promise<T>): Promise<T> {
        this.setBusy(true);
        const callback = () => this.setBusy(false);
        promise.then(callback, callback);
        return promise;
    }
}
